var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "客户经理项目人部门成员信息", width: 60 },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "modelForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.modelForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("FormItem", { attrs: { label: "说明" } }, [
                    _c("span", [
                      _vm._v(
                        "下拉框选择公司名称(项目表已有的公司和部门)：公司-部门，形成二级联动；成员下拉显示所有已审批通过的客户经理"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择公司", prop: "projectCompany" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          on: { "on-change": _vm.onCompanyChange },
                          model: {
                            value: _vm.modelForm.projectCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectCompany", $$v)
                            },
                            expression: "modelForm.projectCompany",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c("Option", {
                            key: item.projectCompany,
                            attrs: {
                              value: item.projectCompany,
                              label: item.projectCompany,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择部门", prop: "projectName" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.modelForm.projectName,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectName", $$v)
                            },
                            expression: "modelForm.projectName",
                          },
                        },
                        _vm._l(_vm.deptList, function (item) {
                          return _c("Option", {
                            key: item.projectName,
                            attrs: {
                              value: item.projectName,
                              label: item.projectName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择成员", prop: "projectCode" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.modelForm.projectCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectCode", $$v)
                            },
                            expression: "modelForm.projectCode",
                          },
                        },
                        _vm._l(_vm.memberList, function (item) {
                          return _c("Option", {
                            key: item.userName,
                            attrs: {
                              value: item.userName,
                              label: item.userPersonName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "部门类型", prop: "projectType" } },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.modelForm.projectType,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectType", $$v)
                            },
                            expression: "modelForm.projectType",
                          },
                        },
                        [
                          _c("Option", { attrs: { value: "市场部门" } }, [
                            _vm._v("市场部门"),
                          ]),
                          _c("Option", { attrs: { value: "非市场部门" } }, [
                            _vm._v("非市场部门"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }